// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__2QLnf","footer":"ChangeClinic_footer__2aM2f"};